function addCaptions() {
  // Select all img elements
  const images = document.querySelectorAll('img');

  images.forEach(img => {
    // Check if the alt attribute contains "Caption:"
    if (img.alt.includes('Caption:')) {
      // Create a new p element
      const p = document.createElement('p');

      // Add the "caption" class
      p.classList.add('image-auto-caption');
      
      // Set the text of the p element to the part after "Caption:"
      const captionText = img.alt.split('Caption:')[1].trim();
      p.textContent = captionText;

      // Insert the p element after the img element
      img.insertAdjacentElement('afterend', p);
    }
  });
}

// Call the function
addCaptions();
